import { assertNever } from '@varos/util-typescript';
import { ChatControllerBaseConfig } from '../../../base';
import { CallRequestNewController } from './callRequestNewInterface';
import {
    CallRequestNewControllerProps,
    CallRequestNewViewProps,
} from './callRequestNewProps';
import { FiPhone, FiPhoneOff } from 'react-icons/fi';

export function createCallRequestNewController(
    config: ChatControllerBaseConfig
): CallRequestNewController {
    return {
        useProps(context, data, props): CallRequestNewViewProps {
            // Create definition object from integration definition
            const definition = data.definition?.display_name
                ? { display_name: data.definition.display_name }
                : data.integration?.definition_id
                  ? { display_name: data.integration.definition_id }
                  : undefined;

            // Create participants array
            const assistantName = definition?.display_name || 'Assistant';
            const participants = [
                {
                    kind: 'assistant' as const,
                    label: assistantName,
                    speaking: false, // No speaking indicators during connecting state
                    avatar: assistantName.substring(0, 2).toUpperCase(),
                },
                {
                    kind: 'user' as const,
                    label: 'You',
                    speaking: false, // No speaking indicators during connecting state
                    avatar: 'YO',
                },
            ];

            return {
                status: {
                    label: 'Connecting...',
                    description: 'Please wait while we connect to the call',
                    kind: 'connecting',
                    Icon: FiPhone,
                    colorScheme: 'blue',
                },
                participants,
                definition,
                end: {
                    button: {
                        onClick: () => {
                            // TODO: Implement call cancellation during connecting state
                            console.log('Cancel call connection');
                        },
                    },
                },
            };
        },
    };
}
